import { render } from "./ReviewCalculationDialog.vue?vue&type=template&id=f2a21160"
import script from "./ReviewCalculationDialog.vue?vue&type=script&lang=ts"
export * from "./ReviewCalculationDialog.vue?vue&type=script&lang=ts"

import "./ReviewCalculationDialog.vue?vue&type=style&index=0&id=f2a21160&lang=scss"
script.render = render

export default script